import FormationModalComponent from "./FormationModalComponent";

export default FormationModalComponent;